import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api'
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha'
import { createElement } from 'react'

import { CodecovCodeCoverageClient, codeCoverageApiRef } from './api'
import { isCodeCoverageAvailable } from './components/isCodeCoverageAvailable'

const codeCoverageApi = ApiBlueprint.make({
  name: 'code-coverage',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: codeCoverageApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) => new CodecovCodeCoverageClient({ discoveryApi, fetchApi }),
      })
    ),
})

const entityCodeCoverageCard = EntityCardBlueprint.make({
  name: 'code-coverage',
  params: {
    type: 'info',
    filter: isCodeCoverageAvailable,
    loader: () =>
      import('./components/CodeCoverageCard/CodeCoverageCard.tsx').then(m => createElement(m.CodeCoverageCard)),
  },
})

export const codeCoveragePlugin = createFrontendPlugin({
  pluginId: 'code-coverage',
  extensions: [codeCoverageApi, entityCodeCoverageCard],
})

export default codeCoveragePlugin
